import getApiClient from '@/clients/apiClient'
import { FEATURE_FLAGS_ENDPOINT } from '@/constants/ApiEndpoints'

const useFeatureFlagsService = () => {
  /**
   * Get feature flags for the current account
   *
   * @returns {Promise<Array>} - The list of feature flags for the current account.
   */
  const getFeatureFlags = async () => {
    const ApiClient = await getApiClient()
    const response = await ApiClient.get(FEATURE_FLAGS_ENDPOINT)

    return response.data.data
  }

  return {
    getFeatureFlags
  }
}

export default useFeatureFlagsService
